import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { fetchMetaTag } from '../modules/cms-module';
import type { AppState, Dispatch } from '../../types/app.types';

export function useFetchMetaTag(path: string): any {
  const dispatch = useDispatch<Dispatch>();
  const metaTag = useSelector((state: AppState) => state.cms.metaTag[path]);
  useEffect(() => {
    if (path && !metaTag) {
      dispatch(fetchMetaTag(path));
    }
  }, [dispatch, path, metaTag]);
  return metaTag || {};
}
